import { LitElement, html, svg } from 'lit';

export class IconGraphLine16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Linjegraf</title><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M2 1.5v13"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m2 10 3.5-3.5 4 3.5L14 5"></path></svg>`; }
}
if (!customElements.get('f-icon-graph-line16', IconGraphLine16)) {
  customElements.define('f-icon-graph-line16', IconGraphLine16);
}